import awaitWrap from '../../../../procedures/await-wrap';
import destroyConfirm from '../../../../procedures/destroy-confirm';
import httpWrap from '../../../../procedures/http-wrap';
import notifyError from '../../../../procedures/notify-error';
import action from '../../../abstract/action.js';

const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        softDelete,
      },
      vars: {
        softDelete: {
          title,
          text,
          successText,
        },
      },
    },
  },
) => {
  await destroyConfirm({
    $vs,
    title: await awaitWrap(title)(item),
    text: await awaitWrap(text)(item),
    action: async () => await httpWrap({
      $vs,
      action: softDelete,
      success: { text: successText },
      onSuccess: reloadList,
      onError: (error) => {
        if (error.response.data.message !== 'Płaca na dany okres istnieje') {
          notifyError({ $vs, text: 'Nie udało się usunąć nieobecności.' });
          return;
        }
        item.additionalData = {
          _is_accepted_code_331: true,
        };
        destroyConfirm({
          $vs,
          title: 'Uwaga',
          text: 'Lista płac dla okresu dodawania nieobecności została wystawiona. Usunięcie nieobecności wymaga jej przegenerowania.',
          action: async () => await httpWrap({
            $vs,
            action: softDelete,
            success: { text: successText },
            onSuccess: reloadList,
          })(item),
        });
      },
    })(item),
  });
};

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle,
});
